import { Component, Input } from '@angular/core';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';

@Component({
    selector: 'agpr-quota-message',
    templateUrl: './quota-message.component.html',
    styleUrls: ['./quota-message.component.scss'],
    standalone: false
})
export class QuotaMessageComponent {
    @Input() totalUsagePercentage: number;
    @Input() threshold: number;
    @Input() remainingCount: number;
    @Input() remainingThreshold: number;
    @Input() infoMessage: string;
    @Input() warningMessage: string;
    @Input() errorMessage: string;

    readonly messageSeverities = messageSeverityEnum;

    constructor() {}
}
